import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Batch } from '../../../swaggerServices';

@Injectable()
export class BulkUpdateTaxReturnService {

  private selectedTaxReturnList = new BehaviorSubject([]);
  private actionsViewFlag = new BehaviorSubject(false);
  selectedTaxReturns = this.selectedTaxReturnList.asObservable();
  actionsView = this.actionsViewFlag.asObservable();

  constructor() { }

  setTaxReturnList(taxReturnList: any) {
    this.selectedTaxReturnList.next(taxReturnList)
  }

  setActionViewFlag(showActionView: boolean) {
    this.actionsViewFlag.next(showActionView)
  }

}